<template>
  <v-container fluid class="fill-height d-flex justify-center color-background">
    <div>
      <v-row class="d-flex mb-6 height  ">
        <v-col class="pa-2 align-self-center ">
          <v-card rounded max-width="600" elevation="3">
            <v-card-title class="justify-center">
              <span class="text-h4 text-center"
                >Secretaria Municipal de Educação</span
              >
            </v-card-title>
            <v-card-subtitle class="text-center">
              <span class="text-h5">Vaga Integral e Plantão de Férias</span>
            </v-card-subtitle>

            <v-form
              class="d-flex flex-wrap mt-5"
              ref="form"
              @submit.prevent="onSubmit"
              @keydown.enter="onSubmit"
            >
              <v-col cols="12" class="py-0">
                <LoginInput
                  v-model="username"
                  :clearable="false"
                  :uppercase="false"
                  :validator="[(v) => !!v]"
                  label="Usuário"
                />
              </v-col>
              <v-col cols="12" class="py-0">
                <LoginInput
                  v-model="password"
                  :append-icon="showPassword ? 'mdi-eye-off' : 'mdi-eye'"
                  :clearable="false"
                  :type="showPassword ? 'text' : 'password'"
                  :uppercase="false"
                  :validator="[(v) => !!v]"
                  label="Senha"
                  @click:append="showPassword = !showPassword"
                />
              </v-col>
              <v-col cols="12" class="d-flex justify-end pt-0 pb-5">
                <Btn
                  block
                  class="ma-2"
                  icon="mdi-login-variant"
                  label="Entrar"
                  large
                  type="submit"
                />
              </v-col>
              <v-col cols="12">
                <v-divider></v-divider>
              </v-col>
              <v-col cols="12" md="6">
                <Btn
                  block
                  icon="mdi-format-list-numbered"
                  label="Consulta - Vaga Integral"
                  large
                  @click="$emit('show-vaga-integral')"
                />
              </v-col>
              <v-col cols="12" md="6">
                <Btn
                  :class-btn="isMobile ? '' : 'ml-n5'"
                  block
                  icon="mdi-format-list-numbered"
                  label="Consulta - Plantão de Férias"
                  large
                  @click="$emit('show-plantao-ferias')"
                />
              </v-col>
            </v-form>
          </v-card>
        </v-col>
      </v-row>
    </div>
  </v-container>
</template>

<script>
import LoginInput from "@/components/Input";
import Btn from "@/components/Btn";
import { first } from "lodash";
import {
  armazenarCredenciaisErudio,
  setAtribuicaoAtiva,
} from "@/plugins/security";

export default {
  name: "login",
  components: {
    LoginInput,
    Btn,
  },

  data: () => ({
    showPassword: false,
    username: null,
    password: null,
  }),

  computed: {
    isMobile() {
      return this.$vuetify.breakpoint.smAndDown;
    },
  },

  methods: {
    onSubmit() {
      if (!this.$refs.form.validate())
        return this.showMessage(
          "Você precisa informar o nome de usuário e a senha",
          "error"
        );

      this.login();
    },

    async login() {
      await this.$http
        .post("login", {
          login: this.username,
          senha: this.password,
        })
        .then(({ token, id, nome_exibicao: nome, permissao: role }) => {
          localStorage.setItem("token-vaga-integral", token);

          localStorage.setItem("user", JSON.stringify({ id, nome, role }));
        })
        .catch((error) => this.showMessage(error, "error"));

      let { username, password } = this;

      password = btoa(password);

      await this.$erudio
        .post("tokens", { username, password })
        .then((credenciais) => {
          armazenarCredenciaisErudio(credenciais);
          const atribuicaoAtiva = credenciais.usuario.atribuicoes.length
            ? first(credenciais.usuario.atribuicoes)
            : null;

          setAtribuicaoAtiva(atribuicaoAtiva);
          window.location.reload();
        })
        .catch(() =>
          this.showMessage(
            "Falha na autenticação, verifique os dados informados e tente novamente!",
            "error"
          )
        );
    },
  },
};
</script>

<style scoped>
.color-background {
  background-color: #e8eaf6;
}
</style>
